<template>
  <main class="c-main">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
						<div class="d-flex justify-content-between w-100">
							<div class="d-flex">
								<div class="form-group mr-4">
									<date-picker class="w-100" v-model="filter.beginDate" valueType="format" placeholder="Дата с"></date-picker>
								</div>
								<div class="form-group mr-4">
									<date-picker class="w-100" v-model="filter.endDate" valueType="format" placeholder="Дата до"></date-picker>
								</div>
								<div class="form-group">
									<button class="btn btn-success" @click="searchWithFilter()">Фильтр</button>
								</div>
							</div>
							<div>
								<h3>Общее количество: {{ totalCount }}</h3>
							</div>
						</div>

            <div class="table-responsive">
                <table class="table-striped table">
                  <thead>
                    <tr>
                      <th>Свойства</th>
                      <th>Дата создание</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in data" :key="index">
											<td>{{ item.title }}</td>
											<td>{{ $moment(item.created_at).format('DD-MM-YYYY') }}</td>
										</tr>
                  </tbody>
                </table>
              </div>

							<div class="row d-flex justify-content-end">
								<paginate
									:page-count="pagination.count"
									:initial-page="0"
									:page-range="3"
									:margin-pages="2"
									:click-handler="getCurrentPage"
									:prev-text="'<'"
									:next-text="'>'"
									:container-class="'pagination'"
									:page-class="'page-item'"
									:page-link-class="'page-link-item'"
									:prev-class="'prev-pagination'"
									:prev-link-class="'prev-link-pagination'"
									:next-class="'next-pagination'"
									:next-link-class="'next-link-pagination'"
								></paginate>
							</div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { GET } from "@/shared/api";
export default {
  data() {
    return {
			data: [],
			filter: {
				page: 0
			},
			totalCount: 0,
			pagination: {
				count: 0,
				perpage: 20
			}
    };
  },
  methods: {
    getData() {
      GET([], "/report/fields", this, false).then(response => {
				this.data = response.data;
				this.totalCount = response.total;
				this.pagination.count = Math.ceil(response.total / this.pagination.perpage);
      });
		},
		searchWithFilter() {
			GET(this.filter, "/report/fields", this, false).then(response => {
				this.data = response.data;
				this.totalCount = response.total;
				this.pagination.count = Math.ceil(response.total / this.pagination.perpage);
      });
		},
		getCurrentPage(pageNumber) {
			this.filter.page = pageNumber
      GET(this.filter, "/report/fields", this, false).then(response => {
				this.data = response.data;
				this.pagination.count = Math.ceil(response.total / this.pagination.perpage);
      });
    }
  },
  mounted() {
    this.getData();
  }
};
</script>
